import ArticleLayout from '@/components/feature/ArticleLayout';

export default function JacketsArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Jackets: The Ultimate Outerwear Discovery Guide for 2026</title>
      <meta name="description" content="Complete guide to Superbuy Spreadsheet jackets — discover bomber jackets, puffer coats, denim jackets, technical shells, and every outerwear style. Sizing tips, material guides, QC checklists, and curated finds for 2026." />
      <meta name="keywords" content="superbuy spreadsheet jackets, superbuy sheet jackets, superbuy outerwear spreadsheet, best superbuy jackets, superbuy coat guide, superbuy spreadsheet winter jackets, superbuy bomber jacket" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-jackets`} />
      <ArticleLayout slug="superbuy-spreadsheet-jackets" />
    </>
  );
}